"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const index_styles_1 = require("./index.styles");
function RotatedSquareIcon({ squareBgColor = '#000000', circleBgColor = '#ffffff', IconComponent, iconColor = '#000000', IconSize = '20px', squareSize = '28px', success = false, error = false, }) {
    const { squareStyle, iconStyle } = (0, index_styles_1.default)({
        squareBgColor,
        circleBgColor,
        iconColor,
        IconSize,
        squareSize,
        success,
        error,
    });
    return ((0, jsx_runtime_1.jsx)("div", { style: squareStyle, children: (0, jsx_runtime_1.jsx)(IconComponent, { style: iconStyle }) }));
}
exports.default = RotatedSquareIcon;
